import { useState } from 'react';
import { Topbar, Aside, Main, Information, GCardInfo, Loader } from 'components';
import { useGetUser } from 'hooks';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserCircleIcon, ShieldUserIcon } from '@hugeicons/core-free-icons';

const TABS = [
    { id: 0, label: 'Profile Information', icon: UserCircleIcon },
    { id: 1, label: 'GhanaCard & ID',       icon: ShieldUserIcon },
];

function Edit() {
    const { loading, profile } = useGetUser();
    const [activeTab, setActiveTab] = useState(0);

    if (loading) return <Loader />;

    return (
        <main>
            <Topbar />

            <div className='pt-14 w-full flex overflow-hidden bg-light-bg dark:bg-dark-page'>
                <Aside />

                <Main>
                    <div className="space-y-5 py-4">

                        {/* Page header */}
                        <div>
                            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Edit Profile</h1>
                            <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">Update your personal information and identity documents</p>
                        </div>

                        <div className="flex flex-col md:flex-row gap-5">

                            {/* Tab sidebar */}
                            <aside className="md:w-52 shrink-0">
                                <nav className="rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 shadow-sm overflow-hidden">
                                    {TABS.map(tab => (
                                        <button
                                            key={tab.id}
                                            onClick={() => setActiveTab(tab.id)}
                                            className={`w-full flex items-center gap-2.5 px-4 py-3 text-sm font-medium text-left transition-colors border-b border-gray-100 dark:border-white/[.06] last:border-0 ${
                                                activeTab === tab.id
                                                    ? 'text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-500/10'
                                                    : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-white/[.03]'
                                            }`}
                                        >
                                            <HugeiconsIcon
                                                icon={tab.icon}
                                                size={16}
                                                className="shrink-0"
                                                color={activeTab === tab.id ? '#b45309' : 'currentColor'}
                                            />
                                            {tab.label}
                                        </button>
                                    ))}
                                </nav>
                            </aside>

                            {/* Tab content */}
                            <div className="flex-1 min-w-0 rounded-xl border border-gray-200 dark:border-white/[.08] bg-white dark:bg-gray-900 shadow-sm p-5 md:p-6">
                                {activeTab === 0 && <Information profile={profile} />}
                                {activeTab === 1 && <GCardInfo idNumber={profile?.idNumber} />}
                            </div>

                        </div>
                    </div>
                </Main>
            </div>
        </main>
    );
}

export default Edit;
